/* eslint-disable react/no-array-index-key */
import { Tag } from 'antd';

const columns = [
  {
    title: '#',
    dataIndex: 'no',
    width: '60px',
  },
  {
    title: 'Họ và tên',
    dataIndex: 'fullname',
  },
  // {
  //   title: 'Họ lót',
  //   dataIndex: 'lastname',
  // },
  // {
  //   title: 'Tên',
  //   dataIndex: 'firstname',
  // },
  // {
  //   title: 'Giới tính',
  //   dataIndex: 'gender',
  // },
  {
    title: 'Email',
    dataIndex: 'email',
  },
  // {
  //   title: 'Mật khẩu',
  //   dataIndex: 'password',
  // },
  // {
  //   title: 'Xác nhận mật khẩu',
  //   dataIndex: 'confirmPassword',
  // },
  {
    title: 'Cấp',
    dataIndex: 'schoolType',
  },
  // {
  //   title: 'Ngày sinh',
  //   dataIndex: 'birthday',
  // },
  {
    title: 'Loại tài khoản',
    dataIndex: 'type',
    width: '100px',
  },
  // {
  //   title: '',
  //   dataIndex: 'parentFullname',
  // },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
    render: (text, record) => {
      const { status, message } = record;
      return <Tag color={getColor(status)}>{message}</Tag>;
    },
  },
  {
    title: 'Trạng thái mail',
    dataIndex: 'mailStatus',
    width: '100px',
    render: (text, record) => {
      const { mailStatus, mailMessage } = record;
      return <Tag color={getColor(mailStatus)}>{mailMessage}</Tag>;
    },
  },
];

export default columns;

const getColor = (value) => {
  let color = '';
  switch (value) {
    case 1:
      color = 'green';
      break;
    case 0:
      color = 'red';
      break;
    default:
      color = 'blue';
      break;
  }
  return color;
};

